export default __webpack_public_path__ + "static/media/15.7441b328.pdf";